<div class="add-edit-calendar-category-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="header-icon" aria-hidden="true">
      <mat-icon>category</mat-icon>
    </div>
    <div class="header-content">
      <h2 class="dialog-title">{{itemData?.id ? 'Edit' : 'Create'}} categories</h2>
    </div>
    <button class="close-btn" (click)="close()" type="button" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Dialog Content -->
  <div class="dialog-content" [formGroup]="componentForm">
    <div class="form-row">
      <div class="form-group col-12">
        <label for="name" class="custom_label"> Name *</label>
        <input type="text" class="form-control" placeholder="Name your category" formControlName="name"
          id="name">
        <app-validation-error [formGroup]="componentForm" [controlName]="'name'"></app-validation-error>
      </div>
    </div>
    <div class="form-row color-section">
      <div class="form-group col-12">
        <label class="custom_label">Color</label>
        <div class="color-options">
          @for (color of colorOptions; track color; let i = $index) {
            <div class="color-circle"
              [ngStyle]="{'background-color': color}" [class.orange-border]="i === 0"
              [class.selected]="colorTouched && selectedColor === color && i !== 0"
              (click)="selectColor(color)">
              <span class="color-letter">B</span>
              @if (i === 0) {
                <span class="plus-icon" (click)="openColorDialog()">+</span>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Dialog Footer -->
  <div class="dialog-footer">
    <button class="btn-cancel" (click)="close()">
      <mat-icon>close</mat-icon>
      Cancel
    </button>
    <button class="btn-action" (click)="save()" [disabled]="requestInProgress">
      <mat-icon>check_circle</mat-icon>
      {{itemData?.id ? 'Update' : 'Save'}}
    </button>
  </div>
</div>